import "../../../scss/pickup-point-information.scss";
import { Table } from "react-bootstrap";

const PickupPointInformation = () => {
  return (
    <div className={"pickup-point-information d-flex flex-column"}>
      <h2>Pickup Points &amp; FAQs</h2>

      <section className={"d-flex flex-column"}>
        <h3>Location Details</h3>
        <Table responsive>
          <thead>
            <tr>
              <td>#</td>
              <td>Agent Name</td>
              <td>Pickup Point / Location</td>
              <td>Open / Close Time</td>
              <td>Open Days</td>
              <td>Google Map Pin</td>
            </tr>
          </thead>
          <tbody>
            <tr className="zone-header-row">
              <td colSpan={6}>
                ZONE 1 &bull; Waiyaki Way / Westlands spillover &bull; KES 140 /
                parcel
              </td>
            </tr>
            <tr>
              <td>1</td>
              <td>Jogam Ventures</td>
              <td>N Market (Kangemi)</td>
              <td>7:30 am – 10:00 pm</td>
              <td>Mon–Fri &amp; Sun (Sat closed)</td>
              <td>
                <a
                  href="https://www.google.com/maps?q=-1.2644664,36.7298866&z=17&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>SP1 Sleek Barber and Beauty</td>
              <td>Kinoo (Muhuri Road, 87 Junction)</td>
              <td>Tue–Sat 8:00 am – 8:00 pm; Sun 11:00 am – 9:00 pm</td>
              <td>Tue–Sun (Mon closed)</td>
              <td>
                <a
                  href="https://www.google.com/maps/search/SP1%20Sleek%20Barber%20and%20Beauty/@-1.2623108625411987,36.70161437988281,17z?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>Moveka Limited</td>
              <td>CBD: Central Building, 1st Floor</td>
              <td>9:00 am – 6:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>—</td>
            </tr>

            <tr className="zone-header-row">
              <td colSpan={6}>
                ZONE 2 &bull; Lang&apos;ata / Ngong / Inner Eastlands / Inner
                Thika Rd &bull; KES 140 / parcel
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>Westies Thrift Zone</td>
              <td>Buruburu (Mesora)</td>
              <td>8:00 am – 8:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/QVbqXWhwZJnHhCZHA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>Print Solution Cyber</td>
              <td>Donholm (Savanna)</td>
              <td>8:00 am – 9:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/yvvTz7SEe5w9DFsN8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>Fancy Salon</td>
              <td>Umoja Innercore</td>
              <td>Mon–Sat 8:30 am – 8:30 pm; Sun 2:00 – 7:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/6FujJEQKyfLPs3Ed9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>Nosh Gamers</td>
              <td>Roysambu (TRM Drive)</td>
              <td>9:00 am – 8:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/icjFGABjP1J3W9549"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>Maya Care</td>
              <td>Lang&apos;ata (Dam Estate)</td>
              <td>8:00 am – 11:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/MkLJft6BQ1J58ED76"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>Piga Copy</td>
              <td>Milele Mall</td>
              <td>
                Mon–Fri 8:15 am – 8:30 pm; Sat 9:00 am – 8:30 pm; Sun 2:00 –
                7:00 pm
              </td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/m9jLXjnUueSoq3jK7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>10</td>
              <td>Xtreme Media</td>
              <td>Tumaini (Rongai)</td>
              <td>Mon–Sat 8:00 am – 9:00 pm; Sun 12:00 – 9:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/68fHC35crx2rA9wW9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>11</td>
              <td>Battery Center</td>
              <td>Fedha Stage</td>
              <td>9:00 am – 7:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/XUEA9C71uGp8WqT5A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>

            <tr className="zone-header-row">
              <td colSpan={6}>
                ZONE 3 &bull; Outer Eastlands / Rongai / Outer Thika Rd &bull;
                KES 140 / parcel
              </td>
            </tr>
            <tr>
              <td>12</td>
              <td>Endless Fancywear</td>
              <td>Komarock (near K-Mall)</td>
              <td>8:00 am – 8:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/cUckij6D6NubtUz38"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>13</td>
              <td>Emmah White Meat</td>
              <td>Utawala (Shopping Mall)</td>
              <td>9:30 am – 8:30 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/7RnozrdoyGgL3MU39"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>14</td>
              <td>Vision Tech Cyber</td>
              <td>Ruai</td>
              <td>Mon–Fri 7:00 am – 7:30 pm; Sat 9:00 am – 5:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/pNbTFEVm6sAF1CzDA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>15</td>
              <td>Bricah Shoes Collection</td>
              <td>Kasarani (Equity Stage)</td>
              <td>8:00 am – 8:30 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://www.google.com/maps?q=-1.2178716,36.899766&z=17&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>16</td>
              <td>Mathao Cyber</td>
              <td>Zimmerman Stage</td>
              <td>9:00 am – 11:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/dE5U6HnKNyLhjipp9?g_st=ac"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>17</td>
              <td>Nosh Gamers</td>
              <td>Kahawa Wendani</td>
              <td>9:30 am – 10:30 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/5sztPU4pjYf3eTNC7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>18</td>
              <td>Alfkin</td>
              <td>Kahawa West</td>
              <td>8:00 am – 6:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://www.google.com/maps?q=-1.1865222,36.9087417&z=17&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>19</td>
              <td>Mirema Movies</td>
              <td>Mirema</td>
              <td>9:00 am – 8:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://www.google.com/maps?q=-1.2131169,36.8941474&z=17&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>20</td>
              <td>Westies Thrift Zone</td>
              <td>Roasters (Opp. Magunas)</td>
              <td>8:00 am – 8:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/aQHmyRLasuhiJ8dw7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>21</td>
              <td>Xtreme Media</td>
              <td>Tusky&apos;s (Rongai)</td>
              <td>Mon–Sat 8:00 am – 9:00 pm; Sun 12:00 – 9:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/UzQbPKwWMFNu7kaq7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>22</td>
              <td>Xtreme Media</td>
              <td>Masai Lodge</td>
              <td>Mon–Sat 8:00 am – 9:00 pm; Sun 12:00 – 9:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/PC9a3DovouWFHcZD8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>23</td>
              <td>BeiBei Apparel</td>
              <td>Ruaka (Equity Afya)</td>
              <td>9:00 am – 6:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/aga1VpSACArmZpT16"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>

            <tr className="zone-header-row">
              <td colSpan={6}>
                ZONE 4 &bull; Ruiru / Kiserian &mdash; furthest reach &bull; KES
                140 / parcel
              </td>
            </tr>
            <tr>
              <td>24</td>
              <td>Sort It Enterprises</td>
              <td>Ruiru Ndani</td>
              <td>7:30 am – 7:30 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://www.google.com/maps?q=-1.1468338,36.9588885&z=17&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>25</td>
              <td>Shikx Closet</td>
              <td>Githurai 44</td>
              <td>9:00 am – 9:30 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/YDhoMeUBm7WXfWFC7?g_st=ac"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>26</td>
              <td>Xtreme Media</td>
              <td>Kiserian</td>
              <td>Mon–Sat 8:00 am – 9:00 pm; Sun 12:00 – 9:00 pm</td>
              <td>Daily (Mon–Sun)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/cVvwz7YJxJJdVpEu8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>27</td>
              <td>Spartan Gamers</td>
              <td>Mlolongo</td>
              <td>9:00 am – 6:00 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/7n14RZD9RkRtE4kE7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
            <tr>
              <td>28</td>
              <td>Healthy Drip</td>
              <td>Syokimau (Katani Road)</td>
              <td>9:00 am – 7:30 pm</td>
              <td>Mon–Sat (Sun closed)</td>
              <td>
                <a
                  href="https://maps.app.goo.gl/S4qRs2kCs7GqzFfJ9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                </a>
              </td>
            </tr>
          </tbody>
        </Table>
      </section>

      <section className={"d-flex flex-column"}>
        <h3>FAQs</h3>

        <div className="faq-item">
          <p className="faq-question">What are the size limits?</p>
          <p className="faq-answer">
            Packages may not be over 5kg and packages may not be bulky (i.e. not
            larger than 17kg volumetric or 30 cm on the longest side).
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">What if my package is damaged?</p>
          <p className="faq-answer">
            Damage should be reported immediately by WhatsApp (0116047339) or
            email with photos while at the agent pick up point. Shipping is at
            the Sender&apos;s own risk and merchants are recommended to follow
            packaging recommendations and not to ship fragile items. ShipShap
            company shall not be held liable for any damage claim.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">What if my package is lost?</p>
          <p className="faq-answer">
            Loss is covered up to KES 2,000 per package. Package value must be
            declared in advance of shipping and a commercial invoice provided
            upon request to be eligible for any coverage. Coverage will not
            exceed declared or commercial invoice value.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">Do you provide returns?</p>
          <p className="faq-answer">
            No. If a customer wishes to return an item, they need to arrange
            with the merchant.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">What is Pickup Point?</p>
          <p className="faq-answer">
            A convenient parcel collection and drop-off solution designed to
            simplify deliveries.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">How does it work?</p>
          <p className="faq-answer">
            Simply choose a Pickup Point when sending or receiving a parcel. We
            deliver the parcel to your selected location, and once it arrives,
            the receiver will receive a notification and a unique OTP (One-Time
            Password). To collect the parcel, the receiver visits the Pickup
            Point and presents the OTP for verification as well as ID, and signs
            for the delivery. Parcels can be collected at any time within the
            3-day pickup window, making deliveries more convenient, secure, and
            hassle-free.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">
            How long can parcels stay at a Pickup Point?
          </p>
          <p className="faq-answer">
            Customers have a 3-day collection window. After 3 days the parcel
            will be returned to the sorting centre and will need to be shipped
            out afresh upon a new label creation. Customers receive 3 pick up
            reminders.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">
            What if I want to send someone to pick the package on my behalf?
          </p>
          <p className="faq-answer">
            The receiver needs to provide the person collecting the package
            their OTP and a copy of their ID.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">
            Is Pickup Point available across Nairobi?
          </p>
          <p className="faq-answer">
            Yes. Pickup Points are strategically located across Nairobi. Dropoff
            in Westlands or CBD, pickup as far away as Kiserian, Kitengela,
            Ruiru, Waiyaki Way, Kinoo or Ruaka.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">How fast is delivery?</p>
          <p className="faq-answer">The routes support next-day delivery.</p>
        </div>

        <div className="faq-item">
          <p className="faq-question">What is the Drop Off cut off time?</p>
          <p className="faq-answer">
            Packages must be dropped off by noon for next day delivery.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">How much does it cost?</p>
          <p className="faq-answer">Shipping an order starts at KES 150.</p>
        </div>

        <div className="faq-item">
          <p className="faq-question">Can merchants use Pickup Point?</p>
          <p className="faq-answer">
            Yes. Pickup Point is designed for both businesses and individual
            customers.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">Why is Pickup Point more affordable?</p>
          <p className="faq-answer">
            The model reduces failed delivery attempts and optimizes last-mile
            delivery operations.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">Can orders be tracked?</p>
          <p className="faq-answer">
            Yes. Customers receive tracking updates throughout the delivery
            process.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">Is there anything you don&apos;t ship?</p>
          <p className="faq-answer">
            Perishable goods (e.g. food), bulky items, electronics, cash/money,
            explosives, biohazardous materials, animals, and illegal items. We
            recommend against shipping fragile items and such items are shipped
            entirely at the sender&apos;s own risk.
          </p>
        </div>

        <div className="faq-item">
          <p className="faq-question">
            Why should I use Pickup Points instead of door-to-door delivery?
          </p>
          <p className="faq-answer">
            Pickup Points are a great option when door-to-door delivery may
            require multiple attempts or when customers are difficult to reach
            during the day. Instead of riders coordinating around changing
            locations or availability, customers can collect their parcels from
            a convenient Pickup Point at a time that works better for them. This
            makes delivery more flexible for customers while helping merchants
            improve completion rates.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PickupPointInformation;
